import { useSelector, useDispatch } from "react-redux";

import {
    Container,
    Grid,
    Box,
    Paper
} from "@mui/material";

import Button from "@/components/ph/Button";

import { nextStep, updateQuote } from "../../quote/quoteSlice";

import { isFormValid } from "../selectors/contractorSelectors";

// 1. IMPORT ACTUALIZADO a la nueva taxonomía (Paso 3)
import { trackEventStep3Continue } from "../../../utils/analytics";

const ContractorButton = () => {
  const dispatch = useDispatch();
  const canSubmit = useSelector(isFormValid);
 
  const handleSubmit = async () => {

    const result = await dispatch(updateQuote()).unwrap();

    if (result) {
      try {
        await trackEventStep3Continue();
      } catch (error) {
        console.warn("Error de analítica al continuar paso 3:", error);
      }
      
      dispatch(nextStep());
    }
  };

  return (
  <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
    <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
      <Grid size={{ xs: 12, md: 12 }}>
        <Box sx={{
          mt: 6,
          maxWidth: {
            xs: 'none',
            md: 225
          },
          mx: 'auto'
        }} alignItems="center">
          <Button
            label="Continuar"
            onClick={handleSubmit}
            variant="black"
            disabled={!canSubmit}
          />
        </Box>
      </Grid>
    </Paper>
  </Container>
  );
};

export default ContractorButton;
